import { render, staticRenderFns } from "./RejectCategoryWizard.vue?vue&type=template&id=007b66f2&scoped=true"
import script from "./RejectCategoryWizard.vue?vue&type=script&lang=js"
export * from "./RejectCategoryWizard.vue?vue&type=script&lang=js"
import style0 from "./RejectCategoryWizard.vue?vue&type=style&index=0&id=007b66f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b66f2",
  null
  
)

export default component.exports